import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'user-gdpr-dialog',
    templateUrl: 'user-gdpr-dialog.html',
    styleUrls: ['./user-gdpr-dialog.scss']
})
export class UserGdprDialog implements OnInit {
    @Input() showMe: boolean = false;
    @Output() onCloseDlg = new EventEmitter<any>();
    userId: string = '';

    constructor() { }

    ngOnInit() {
        this.initServices();
    }

    initServices() {

    }

    closeDialog(isGetData: boolean) {
        this.onCloseDlg.emit(isGetData ? this.userId.trim() : '');
        this.showMe = false;
    }
}
